<template>
  <div id="calculator">
    <div class="calc-container">
      <section>
        <article>
          <div class="tooltip-container">
            <h3>Total Lost Revenue</h3>
            <font-awesome-icon id="total-rev" class="fa-fw" :icon="['fal', 'info-circle']"/>
            <b-tooltip target="total-rev" placement="right" triggers="click">
              <button class="close-btn" @click="$root.$emit('bv::hide::tooltip')">X</button>
              Total of all lost revenue.
            </b-tooltip>
          </div>

          <template v-if="calculations && submitted">
            <p>${{ totalCostOfTurnover.total.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  })  }}</p>
          </template>
          <template v-else>
            <p>No Data</p>
          </template>
        </article>

        <article>
          <div class="tooltip-container">
            <h3>Vacancy Costs</h3>
            <font-awesome-icon id="vac-cost" class="fa-fw" :icon="['fal', 'info-circle']"/>
            <b-tooltip target="vac-cost" placement="right" triggers="click">
              <button class="close-btn" @click="$root.$emit('bv::hide::tooltip')">X</button>
              The revenue a dealerships loses when an experienced technician leaves and a bay is vacant during the recruiting phase
            </b-tooltip>
          </div>
          <template v-if="calculations && submitted">
            <p>${{ vacancyCostLoss.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 }) }}</p>
          </template>
          <template v-else>
            <p>No Data</p>
          </template>
        </article>

        <article>
          <div class="tooltip-container">
            <h3>Recruiting Costs</h3>
            <font-awesome-icon id="recruit-cost" class="fa-fw" :icon="['fal', 'info-circle']"/>
            <b-tooltip target="recruit-cost" placement="right" triggers="click">
              <button class="close-btn" @click="$root.$emit('bv::hide::tooltip')">X</button>
              The recruiting costs associated with replacing a technician
            </b-tooltip>
          </div>
          <template v-if="calculations && submitted">
            <p>${{ totalInterviewingRecruitingCost.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  }) }}</p>
          </template>
          <template v-else>
            <p>No Data</p>
          </template>
        </article>

        <article>
          <div class="tooltip-container">
            <h3>Production Costs</h3>
            <font-awesome-icon id="product-cost" class="fa-fw" :icon="['fal', 'info-circle']"/>
            <b-tooltip target="product-cost" placement="right" triggers="click">
              <button class="close-btn" @click="$root.$emit('bv::hide::tooltip')">X</button>
              The revenue a dealership loses by having a less experienced hire take the place of a more experienced technician
            </b-tooltip>
          </div>
          <template v-if="calculations && submitted">
            <p>${{ lostProductionCosts.datasets[2].data[1].toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  }) }}</p>
          </template>
          <template v-else>
            <p>No Data</p>
          </template>
        </article>

        <article>
          <b-button class="ford-btn active" v-b-modal.trtcalc>Inputs</b-button>
        </article>
      </section>

      <section class="margin-row">
        <div class="calculation-toggle">
<!--          <b-button class="ford-btn" :class="{active: selected === 'revenue'}" @click="calculate('revenue')">Revenue</b-button>-->
<!--          <b-button class="ford-btn"  :class="{active: selected === 'profit'}" @click="calculate('profit')">Profit</b-button>-->
<!--          <b-button class="ford-btn" :class="{active: selected === 'revenue'}" @click="selected = 'revenue'">Revenue</b-button>-->
<!--          <b-button class="ford-btn"  :class="{active: selected === 'profit'}" @click="selected = 'profit'">Profit</b-button>-->
          <template v-if="!submitted">
            <b-button class="ford-btn" :class="{active: selected === 'revenue'}" @click="selected = 'revenue'">Revenue</b-button>
            <b-button class="ford-btn"  :class="{active: selected === 'profit'}" @click="selected = 'profit'">Profit</b-button>
          </template>
          <template v-else>
            <b-button class="ford-btn" :class="{active: selected === 'revenue'}" @click="calculate('revenue')">Revenue</b-button>
            <b-button class="ford-btn"  :class="{active: selected === 'profit'}" @click="calculate('profit')">Profit</b-button>
          </template>
        </div>
<!--        <div class="btn-link">Definitions</div>-->
      </section>

      <div class="margin-row" v-if="calculations && submitted">
         <div class="charts">
<!--           <div>-->
           <b-card>
             <h4>{{ selectedType(selected) }}</h4>
             <p class="chart-title">Total Cost of Turnover</p>
             <p class="sub-title"></p>
             <bar-chart :chart-data="totalCostOfTurnover" title="Total Cost of Turnover" legendPosition="right" v-if="totalCostOfTurnover"></bar-chart>
           </b-card>

           <b-card>
             <h4>{{ selectedType(selected) }}</h4>
             <p class="chart-title">Vacancy Costs</p>
             <p class="sub-title">Gross Sales Loses</p>
             <bar-chart :chart-data="vacancyCosts" title="Vacancy Costs" legendPosition="right" v-if="vacancyCosts"></bar-chart>
           </b-card>

           <b-card>
             <h4>{{ selectedType(selected) }}</h4>
             <p class="chart-title">Recruiting Costs</p>
             <p class="sub-title">Interviewing & Screening costs</p>
             <pie-chart :chart-data="recruitingCosts" v-if="recruitingCosts"></pie-chart>
           </b-card>

           <b-card>
             <h4>{{ selectedType(selected) }}</h4>
             <p class="chart-title">Lost Production Costs</p>
             <p class="sub-title">Losses from Decreased Efficiency</p>
             <bar-chart :chart-data="lostProductionCosts" title="Lost Production Costs" legendPosition="bottom" v-if="lostProductionCosts"></bar-chart>
           </b-card>
         </div>
          <!--          <bar-chart :chart-data="totalCostOfTurnover" title="Total Cost of Turnover" v-if="totalCostOfTurnover"></bar-chart>-->
          <!--          <bar-chart :chart-data="vacancyCosts" title="Vacancy Costs" v-if="vacancyCosts"></bar-chart>-->
          <!--          <pie-chart :chart-data="recruitingCosts" v-if="recruitingCosts"></pie-chart>-->
          <!--          <bar-chart :chart-data="lostProductionCosts" title="Lost Production Costs" v-if="lostProductionCosts"></bar-chart>-->

      </div>
      <b-card class="margin-row" v-else>
<!--        <template v-if="calculations">-->
<!--          <b-card>-->
<!--            <bar-chart :chart-data="totalCostOfTurnover" title="Total Cost of Turnover" v-if="totalCostOfTurnover"></bar-chart>-->
<!--          </b-card>-->

<!--          <b-card>-->
<!--            <bar-chart :chart-data="vacancyCosts" title="Vacancy Costs" v-if="vacancyCosts"></bar-chart>-->
<!--          </b-card>-->

<!--          <b-card>-->
<!--            <pie-chart :chart-data="recruitingCosts" v-if="recruitingCosts"></pie-chart>-->
<!--          </b-card>-->

<!--          <b-card>-->
<!--            <bar-chart :chart-data="lostProductionCosts" title="Lost Production Costs" v-if="lostProductionCosts"></bar-chart>-->
<!--          </b-card>-->
<!--&lt;!&ndash;          <bar-chart :chart-data="totalCostOfTurnover" title="Total Cost of Turnover" v-if="totalCostOfTurnover"></bar-chart>&ndash;&gt;-->
<!--&lt;!&ndash;          <bar-chart :chart-data="vacancyCosts" title="Vacancy Costs" v-if="vacancyCosts"></bar-chart>&ndash;&gt;-->
<!--&lt;!&ndash;          <pie-chart :chart-data="recruitingCosts" v-if="recruitingCosts"></pie-chart>&ndash;&gt;-->
<!--&lt;!&ndash;          <bar-chart :chart-data="lostProductionCosts" title="Lost Production Costs" v-if="lostProductionCosts"></bar-chart>&ndash;&gt;-->

<!--        </template>-->
<!--        <template v-else>-->
<!--          No Data Available-->
<!--        </template>-->
        <p class="no-data">No Data Available</p>
      </b-card>

<!--      <b-modal id="trtcalc" hide-footer size="xl" ref="modal" static>-->
        <b-modal id="trtcalc" size="xl" ref="modal" static>
<!--        <template #modal-title>-->
<!--          Tech Retention Tool Calculator-->
<!--        </template>-->
        <div class="d-block text-left">
          <Calculator ref="calculator" @calculations="showCharts" @submitted="updateToggleBtns" @closeModal="$bvModal.hide('trtcalc')" :selected="selected"></Calculator>
        </div>
<!--        <b-button class="mt-3" block @click="$bvModal.hide('trtcalc')">Close Me</b-button>-->
        <!--      <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button>-->

        <template #modal-footer>
          <div class="footer-btns">
            <b-button class="chart-btn" @click="validateInputs">Chart Inputs</b-button>
            <b-button class="clear-btn" @click="clearInputs">Clear Inputs</b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import PieChart from './charts/Pie.js';
  import BarChart from './charts/Bar.js';
  import Calculator from './Calculator';

  export default {
    name: 'ROICalculator',
    data() {
      return {
        selected: 'revenue',
        calculations: false,
        datacollection: null, // line example
        recruitingCosts: null, // Pie
        totalInterviewingRecruitingCost: null, // total for graphs
        vacancyCosts: null, // Bar
        vacancyCostLoss: null, // total for bar graph
        revenueLost: null, // Bar graphs
        totalCostOfTurnover: null, // Bar graph
        lostProductionCosts: null, // Bar Graph,
        submitted: false
      }
    },
    components: {
      // Calculator: () => import('./Calculator'),
      Calculator,
      PieChart,
      BarChart
    },
    created() {},
    mounted() {
      this.$root.$on('bv::tooltip::show', () => {
        this.$root.$emit('bv::hide::tooltip')
      });

      // Handles off click anywhere for tooltip
      document.addEventListener('click', () => {
        this.$root.$emit('bv::hide::tooltip')
      })
    },
    beforeDestroy: function () {
      document.removeEventListener('click')
    },
    methods: {
      validateInputs() {
        if (this.$refs.calculator) {
          this.$refs.calculator.validateInputs();
        }
      },
      clearInputs() {
        if (this.$refs.calculator) {
          this.$refs.calculator.clearInputs();
        }
      },
      calculate(type) {
        if (this.$refs.calculator) {
          this.$refs.calculator.calculate(type);
          this.selected = type;
        }
      },
      showCharts(calculations) {
        console.log('SHOW CHARTS', calculations)

        if (calculations) {
          this.datacollection = calculations.datacollection;
          this.recruitingCosts = calculations.recruitingCosts;
          this.totalInterviewingRecruitingCost = calculations.totalInterviewingRecruitingCost;
          this.vacancyCosts = calculations.vacancyCosts;
          this.vacancyCostLoss = calculations.vacancyCostLoss;
          this.revenueLost = calculations.revenueLost;
          this.totalCostOfTurnover = calculations.totalCostOfTurnover;
          this.lostProductionCosts = calculations.lostProductionCosts;

          // Sum total for Total Cost of Turnover
          let total = 0;
          for (let i = 0; i < this.totalCostOfTurnover.datasets.length; i++)
            total += this.totalCostOfTurnover.datasets[i].data[0];

          this.totalCostOfTurnover.total = total;




          // Show calcs
          this.calculations = true;
        }
      },
      updateToggleBtns(status) {
        this.submitted = status;
      },
      selectedType(type) {
        return type.charAt(0).toUpperCase() + type.slice(1);
      }
    },
    computed: {},
    watch: {}
  }
</script>

<style lang="scss" scoped>
  .calc-container {
    width: 100%;
    margin: 0 0 50px 0;
  }

  .margin-row {
    margin: 0 37px;
  }

  .card {
    background: rgb(255, 255, 255);
    border-radius: 0px;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    min-height: 180px;
  }

  .btn-link {
    background: transparent;
    color: $fordBlueDark;
    font-family: FordAntenna-Medium;
    font-size: 14px;
    font-weight: 500;
    height: 21px;
    letter-spacing: 1px;
    line-height: 21px;
    text-align: right;
    text-decoration: underline;
    border: none !important;

    &:hover {
      background: transparent;
      color: $fordBlueHover;
    }
  }

  .charts {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    /*flex-basis: 150px;*/
    .card {
      margin: 37px 0;
    }

    h4 {
      color: rgb(110, 110, 110);
      font-family: FordAntenna-Regular;
      font-size: 11px;
      font-weight: normal;
      height: 16px;
      letter-spacing: 1px;
      line-height: 16px;
      margin: 0;
    }
    .chart-title {
      color: $fordBlueDark;
      font-family: FordAntenna-Regular;
      font-size: 18px;
      font-weight: normal;
      height: 24px;
      letter-spacing: 0px;
      line-height: 24px;
      margin: 0;
    }

    .sub-title {
      color: rgb(77, 77, 77);
      font-family: FordAntenna-Regular;
      font-size: 14px;
      font-weight: normal;
      height: 21px;
      letter-spacing: 1px;
      line-height: 21px;
    }
  }
#calculator {
  .no-data {
    color: rgb(77, 77, 77);
    font-family: FordAntenna-Regular;
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 0;
    text-align: center;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  section {
    &:first-of-type {
      background: rgb(255, 255, 255);
      border-radius: 3px;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
      min-height: 76px;
      height: auto;
      margin: 0 0 75px 0;
      width: 100%;
      padding: 10px 15px 0;
      display: flex;
      flex-align: center;
      justify-content: space-between;

      @media (max-width: 767px) {
        flex-direction: column;
      }

      article {
        padding: 0 15px 15px;

        &:not(:first-child) {
          border-left: 1px solid black;
        }

        h3 {
          color: rgb(0, 9, 91);
          font-family: FordAntenna-Regular;
          font-size: 11px;
          height: 16px;
          letter-spacing: 1px;
          line-height: 16px;
          margin: 0 5px 0 0;
        }

        p {
          color: rgb(0, 9, 91);
          font-family: FordAntenna-Medium;
          font-size: 18px;
          font-weight: 500;
          height: 24px;
          letter-spacing: 0px;
          line-height: 24px;
        }

        @media (max-width: 767px) {
          &:not(:first-child) {
            border-left: none;
          }
          &:not(:last-child) {
            border-left: none;
            border-bottom: 1px solid black;
          }
          /*border-bottom: 1px solid black;*/
          padding: 15px;
        }
      }
    }

    &:nth-of-type(2) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 56px;
    }
  }

  .ford-btn {
    color: $fordBlueDark;
    font-family: FordAntennaCond-Regular;
    font-size: 18px;
    font-weight: normal;
    height: 40px;
    letter-spacing: 1px;
    line-height: 0;
    text-align: center;
    background: white;
    border: 1px solid #6E6E6E;
    border-radius: 20px;
    padding: 12px 32px;
    /*transform: scale(1); !* you need a scale here to allow it to transition in both directions *!*/
    transition: 0.3s padding ease;

    &.active {
      background: $fordBlueDark;
      border:  $fordBlueDark;
      color: rgb(255, 255, 255);
    }
    &:hover {
      background: $fordBlueHover;
      /*padding: 14px 36px;*/
      text-decoration: none !important;
      color: rgb(255, 255, 255);
      /*transform: scale(.2); !* you need a scale here to allow it to transition in both directions *!*/
    }

    &:focus {
      outline: 0;
      box-shadow: none;
    }

    &:active {
      outline: 0;
      box-shadow: none;
    }
  }

  .calculation-toggle {
    display: flex;
    align-items: center;
    button {
      display: block;
      margin: 0 -30px 0 0;
      transition: none;

      &:first-of-type {
        text-align: left;
        padding: 12px 44px 12px 20px;

        &.active {
          background: $fordBlueDark;
          z-index: 1;
          padding: 21px 32px;
          text-align: center;
        }

        &:hover {
          background: white;
          color: $fordBlueDark;
          &.active {
            background: $fordBlueDark;
            z-index: 1;
            padding: 21px 32px;
            text-align: center;
            color: white;
          }
        }
      }
      &:last-of-type {
        text-align: right;
        padding: 12px 20px 12px 44px;
        &.active {
          background: $fordBlueDark;
          z-index: 1;
          padding: 21px 32px;
          text-align: center;
        }

        &:hover {
          background: white;
          color: $fordBlueDark;
          &.active {
            background: $fordBlueDark;
            z-index: 1;
            padding: 21px 32px;
            text-align: center;
            color: white;
          }
        }
      }
    }
  }
}

.tooltip-container {
  display: flex;
  align-items: center;
}


  .btn {
    &.chart-btn {
      font-family: FordAntennaCond-Regular;
      background: $fordBlueDark;
      color: #fff;
      font-size: 18px;
      font-weight: normal;
      letter-spacing: 1px;
      line-height: 24px;
      text-align: center;
      border-radius: 20px;
      height: 40px;
      max-width: 194px;
      width: 100%;
      border: none;
      outline: 0;
      margin: 0 15px 0 0;

      &:hover {
        background: $fordBlueHover;
        text-decoration: none !important;
      }

      &:focus {
        outline: 0;
        box-shadow: none;
      }

      &:active {
        outline: 0;
        box-shadow: none;
      }

      @media (max-width: 767px) {
        max-width: 100%;
      }
    }

    &.clear-btn {
      @extend .chart-btn;
      background: white;
      color: $fordBlueDark;
      &:hover {
        color :#fff;
      }
    }
  }

</style>



<style lang="scss">
  .tooltip.show {
    opacity: 1 !important;
    color: $fordBlueDark !important;
  }

  .tooltip {
    opacity: 1 !important;
  }

  .tooltip-inner {
    z-index: 999 !important;
    background-color: #fff !important;
    box-shadow: 0 0 4px black;
    opacity: 1 !important;
    color: $fordBlueDark !important;
    text-align: left !important;
    padding: 10px !important;
  }

  .tooltip.bs-tooltip-right .arrow:before {
    border-right-color: #fff !important;
  }

  .tooltip.bs-tooltip-left .arrow:before {
    border-left-color: #fff !important;
  }

  .tooltip.bs-tooltip-bottom .arrow:before {
    border-bottom-color: #fff !important;
  }

  .tooltip.bs-tooltip-top .arrow:before {
    border-top-color: #fff !important;
  }

  .close-btn {
    background: transparent;
    color: $fordBlueDark !important;
    border: none;
    outline: 0;
    box-shadow: none;
    float: right;
    z-index: 998 !important;
  }

  .fa-fw {
    &:hover {
      cursor: pointer;
    }
  }
</style>
